/* eslint-disable import/order */
import React, { PureComponent } from 'react'
import { immutableSelector } from '@/utils'
import { Upload } from '@watchface/components'
import { InfoCircleOutlined } from '@ant-design/icons'
import { renderCells } from '@watchface/utils/render'
import T from '@watchface/components/I18n'

class MaskComponent extends PureComponent {
  static keyMap = {}

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      MaskComponent.renderLayer(this.props)
    }
  }

  static renderLayer = (param) => {
    const keyMap = renderCells({
      com: MaskComponent,
      ...param
    })
    MaskComponent.keyMap = Object.assign(MaskComponent.keyMap, keyMap)
  }

  static getCellDatas = ({ data }) => {
    const cells = {
      imageEntity: {},
      vertexEntity: {}
    }
    const cover = MaskComponent.getCoverImage({ data })

    if (cover) {
      cells.imageEntity[cover.key] = cover
    }

    const mask = MaskComponent.getMaskImage({ data })
    if (mask) {
      cells.imageEntity[mask.key] = mask
    }
    return cells
  }

  static getCoverImage = ({ data }) => {
    const { cover } = immutableSelector(data)
    if (cover) {
      return {
        key: 'cover',
        texture: cover,
        left: 0,
        top: 0
      }
    }

    return null
  }

  static getMaskImage = ({ data }) => {
    const { mask } = immutableSelector(data)
    if (mask) {
      return {
        key: 'mask',
        texture: mask,
        left: 0,
        top: 0,
        zIndex: 10000
      }
    }
    return null
  }

  handleInsertImage = (img, option) => {
    const { onChange, data, parentKey } = this.props
    let newData = data
    if (img && img.image) {
      newData = newData.setIn([...option], img.image)
    } else {
      newData = newData.setIn([...option], '')
    }
    onChange([parentKey], newData)
  }

  render() {
    const { watchConfig, data } = this.props
    const { screenWidth, screenHeight } = immutableSelector(watchConfig)
    const { cover, mask } = immutableSelector(data)

    return (
      <>
        <div className="edit-mode-hint">
          <InfoCircleOutlined className="edit-mode-hint-icon" />
          <T id="edit_mode_config_hint" />
        </div>
        <div className="name is-required">
          100% <T id="mask" />
        </div>
        <div className="content">
          <div className="item">
            <div className="col col-v">
              <Upload
                fileCountLimit={1}
                maxWidth={screenWidth}
                maxHeight={screenHeight}
                field={['cover']}
                fileList={cover ? [{ image: cover }] : []}
                onChange={this.handleInsertImage}
              />
            </div>
          </div>
        </div>
        <div className="name is-required">
          70% <T id="mask" />
        </div>
        <div className="content">
          <div className="item">
            <div className="col col-v">
              <Upload
                fileCountLimit={1}
                maxWidth={screenWidth}
                maxHeight={screenHeight}
                field={['mask']}
                fileList={mask ? [{ image: mask }] : []}
                onChange={this.handleInsertImage}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default MaskComponent
